(function() { window.GUID_15e05dfc_36b5_4073_be85_652a9903a4f6 = { getGuid: function() { return "15e05dfc-36b5-4073-be85-652a9903a4f6"; } }; })();
function SetHighlightDrawBoxes(encounterInfo, canvas, callback) {
    if (encounterInfo == null) {
        return;
    }
    setTimeout(function () {
        var result = { DrawBoxFocus: null, ScheduleBoxFocus: null, Source1: null, Source2: null, Looser: null, LocalLooser: null, Winner: null, LocalWinner: null, EntityPath: null };
        if (!String.isNullOrEmpty(encounterInfo.DrawBoxWithFocus)) {
            var drawBoxFocus = $('#' + ParseDrawPosition(encounterInfo.DrawBoxWithFocus), canvas);
            if (drawBoxFocus.length > 0) {
                drawBoxFocus.addClass('SEL');
                result.DrawBoxFocus = drawBoxFocus;
            }
        }
        if (encounterInfo.EncounterNumber != null) {
            var scheduleBoxFocus = $('#E' + encounterInfo.EncounterNumber, canvas);
            if (scheduleBoxFocus.length > 0) {
                if (result.DrawBoxFocus != null) {
                    //scheduleBoxFocus.addClass('Hgl');
                }
                else {
                    scheduleBoxFocus.addClass('SEL');
                }
                result.ScheduleBoxFocus = scheduleBoxFocus;
            }
        }
        if (!String.isNullOrEmpty(encounterInfo.DrawPositionSources)) {
            var sources = encounterInfo.DrawPositionSources.split(";");
            if (sources.length >= 2) {
                let isGoodCanvas = CheckIfIsGoodCanvas(canvas, encounterInfo.FlowBlockIdSource);
                if (isGoodCanvas && encounterInfo.OppIdFocus == null) {
                    if (sources[0] != "") {
                        var source1 = $('#' + ParseDrawPosition(sources[0]), canvas);
                        if (source1.length > 0) {
                            source1.addClass('SRC');
                            result.Source1 = source1;
                        }
                    }
                    if (sources[1] != "") {
                        var source2 = $('#' + ParseDrawPosition(sources[1]), canvas);
                        if (source2.length > 0) {
                            source2.addClass('SRC');
                            result.Source2 = source2;
                        }
                    }
                }
            }
        }
        if (!String.isNullOrEmpty(encounterInfo.LooserDrawPositionDest)) {
            let isGoodCanvas = CheckIfIsGoodCanvas(canvas, encounterInfo.LooserFlowBlockIdDest);
            if (isGoodCanvas) {
                let looser = $('#' + ParseDrawPosition(encounterInfo.LooserDrawPositionDest), canvas);
                if (looser.length > 0) {
                    looser.addClass('LBD');
                    result.Looser = looser;
                }
            }
        }
        if (!String.isNullOrEmpty(encounterInfo.LocalLooserDrawPositionDest)) {
            let isGoodCanvas = CheckIfIsGoodCanvas(canvas, encounterInfo.FlowBlockId);
            if (isGoodCanvas) {
                let looser = $('#' + ParseDrawPosition(encounterInfo.LocalLooserDrawPositionDest), canvas);
                if (looser.length > 0) {
                    looser.addClass('LBD');
                    result.LocalLooser = looser;
                }
            }
        }
        if (!String.isNullOrEmpty(encounterInfo.WinnerDrawPositionDest)) {
            let isGoodCanvas = CheckIfIsGoodCanvas(canvas, encounterInfo.WinnerFlowBlockIdDest);
            if (isGoodCanvas) {
                let winner = $('#' + ParseDrawPosition(encounterInfo.WinnerDrawPositionDest), canvas);
                if (winner.length > 0) {
                    if (winner.data('eid') == null) {
                        winner.addClass('WBD');
                    }
                    result.Winner = winner;
                }
            }
        }
        if (!String.isNullOrEmpty(encounterInfo.LocalWinnerDrawPositionDest)) {
            let isGoodCanvas = CheckIfIsGoodCanvas(canvas, encounterInfo.FlowBlockId);
            if (isGoodCanvas) {
                let winner = $('#' + ParseDrawPosition(encounterInfo.LocalWinnerDrawPositionDest), canvas);
                if (winner.length > 0) {
                    if (winner.data('eid') == null) {
                        winner.addClass('WBD');
                    }
                    result.LocalWinner = winner;
                }
            }
        }
        if (!String.isNullOrEmpty(encounterInfo.EntityId) && encounterInfo.OppIdFocus > 0) {
            var elemntsOfSamePath = $('[data-eid="' + encounterInfo.OppIdFocus + '"]');
            if (elemntsOfSamePath.length > 0) {
                elemntsOfSamePath.addClass('Hgl');
                result.EntityPath = elemntsOfSamePath;
            }
        }
        if (callback != null && IsDefined(typeof (callback))) {
            callback.call(this, result);
        }
        if (lastHighlight.DrawBoxFocus != null) {
            var bracketBoxControls = $('#BracketBoxControls', entityPopup);
            BindBracketBoxEditControls(bracketBoxControls, encounterInfo, result);
        }
        else if (lastHighlight.ScheduleBoxFocus != null) {
            BindScheduleBoxOptions(lastHighlight, encounterInfo, result);
        }
    }, 0);
}
function ResetHighlightDrawBoxes(lastHighlight, data, callback) {
    setTimeout(function () {
        if (lastHighlight.DrawBoxFocus != null) {
            lastHighlight.DrawBoxFocus.removeClass('SEL');
        }
        if (lastHighlight.ScheduleBoxFocus != null) {
            lastHighlight.ScheduleBoxFocus.removeClass('SEL');
            lastHighlight.ScheduleBoxFocus.removeClass('Hgl');
        }
        if (lastHighlight.Source1 != null) {
            lastHighlight.Source1.removeClass('SRC');
        }
        if (lastHighlight.Source2 != null) {
            lastHighlight.Source2.removeClass('SRC');
        }
        if (lastHighlight.Looser != null) {
            lastHighlight.Looser.removeClass('LBD');
        }
        if (lastHighlight.LocalLooser != null) {
            lastHighlight.LocalLooser.removeClass('LBD');
        }
        if (lastHighlight.Winner != null) {
            lastHighlight.Winner.removeClass('WBD');
        }
        if (lastHighlight.LocalWinner != null) {
            lastHighlight.LocalWinner.removeClass('WBD');
        }
        if (lastHighlight.EntityPath != null) {
            lastHighlight.EntityPath.removeClass('Hgl');
        }
        if (lastHighlight.BracketBoxEditControls != null) {
            lastHighlight.BracketBoxEditControls.remove();
        }
        if (lastHighlight.ScheduleBoxEditControls != null) {
            lastHighlight.ScheduleBoxEditControls.remove();
        }
        if (IsDefined(typeof (callback))) {
            callback.call(this, data);
        }
    }, 0);
}
function CheckIfIsGoodCanvas(canvas, flowblockId) {
    return canvas != null && canvas.data('flowblockid') == flowblockId;
}
function GetEncounterInfoOfBracket(flowBlockId, encounterNumber, drawPosition, fromLinker, callback) {
    var data = {};
    data.flowBlockId = flowBlockId;
    data.encounterNumber = encounterNumber;
    data.drawPosition = drawPosition;
    data.fromLinker = fromLinker;
    CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/GetEncounterInfoOfBracket/" + CSParameters.SportEventId, data, function (result) {
        OnEncounterInfoOfBracketObtain(result, callback);
    });
}
function OnEncounterInfoOfBracketObtain(encounterInfos, callback) {
    if (IsDefined(typeof (callback))) {
        callback.call(this, encounterInfos);
    }
    if (IsDefined(typeof (RefreshToolBarButtons))) {
        RefreshToolBarButtons();
    }
}
function ParseDrawPosition(value, fromIdToDrawPosition) {
    if (fromIdToDrawPosition) {
        return value.replace("_", ",").replace("s", "-");
    }
    else {
        return value.replace(",", "_").replace("-", "s");
    }
}
function ParseEncounterNumber(value, fromIdToEncounterNumber) {
    if (fromIdToEncounterNumber) {
        return value.replace("E", "");
    }
    else {
        return "E" + value;
    }
}
function BindBracketBoxEditControls(bracketBoxControls, encounterInfo, result) {
    var scheduleParent = lastHighlight.DrawBoxFocus.parent();
    var bracket = scheduleParent.parent();
    var style = scheduleParent.attr("style");
    bracketBoxControls.attr("style", style);
    bracketBoxControls.remove().appendTo(bracket);
    var splittedStyle = style.split(';');
    var left = splittedStyle[0].replace("left:", "").replace("em", "").trim();
    var top = splittedStyle[1].replace("top:", "").replace("em", "").trim();
    var height = splittedStyle[2].replace("height:", "").replace("em", "").trim();
    var bottom = parseFloat(top) + parseFloat(height);
    bracketBoxControls.css('height', '2em');
    var offset = 0.2;
    var watermarkForceOn = "";
    if (lastHighlight.DrawBoxFocus.hasClass('TL')) {
        bracketBoxControls.addClass('TL');
        bracketBoxControls.css({ top: top - 2 - offset + 'em', left: left + 'em' });
        watermarkForceOn = 'ForcedOnBottom';
    }
    else if (lastHighlight.DrawBoxFocus.hasClass('TR')) {
        bracketBoxControls.addClass('TR');
        bracketBoxControls.css({ top: top - 2 - offset + 'em', left: left + 'em' });
        watermarkForceOn = 'ForcedOnBottom';
    }
    else if (lastHighlight.DrawBoxFocus.hasClass('BL')) {
        bracketBoxControls.addClass('BL');
        bracketBoxControls.css({ top: bottom + offset + 'em', left: left + 'em' });
        watermarkForceOn = 'ForcedOnTop';
    }
    else if (lastHighlight.DrawBoxFocus.hasClass('BR')) {
        bracketBoxControls.addClass('BR');
        bracketBoxControls.css({ top: bottom + offset + 'em', left: left + 'em' });
        watermarkForceOn = 'ForcedOnTop';
    }
    result.BracketBoxEditControls = bracketBoxControls;
    var autoComplete = $('#EntityBaseIdAutoComplete', bracketBoxControls);
    if (autoComplete.length > 0) {
        autoComplete.CSAutoComplete(watermarkForceOn, false);
        autoComplete.on('keyup', function (e) {
            var key = window.event ? e.keyCode : e.which;
            if (key == 13) {
                if ($(this).val() == "") {
                    e.stopPropagation();
                    UpdateEncounterOpponent(null);
                }
                if ($(this).val() != "") {
                    e.stopPropagation();
                    UpdateEncounterOpponent(null, $(this).val());
                }
            }
        });
        document.EntityBaseId.SelectionChange = function () {
            if (this.SelectedItem != null) {
                var newEntityBaseId = this.SelectedItem.value.id;
                UpdateEncounterOpponent(newEntityBaseId);
            }
        };
        var fullVal = autoComplete.val();
        if (fullVal != "") {
            //Extraire le premier HTML (<b) et enlever le reste.
            //Permet d'enlever la junk
            var divPosition = fullVal.indexOf("<b");
            if (divPosition > 1) {
                var smallText = fullVal.substring(0, divPosition - 1);
                autoComplete.val(smallText);
            }
        }
        autoComplete.focus();
        autoComplete.select();
        autoComplete.on('mousedown', function (e) {
            //e.preventDefault(); //Si l'on met preventDefaut, on ne peut pas cliquer entre
            // 2 lettres de l'autocomplete pour éditer le texte entre ces 2 lettres.
            e.stopPropagation();
        });
    }
    var btnIsWinner = $('#BracketBoxBtnIsWinner', bracketBoxControls);
    if (btnIsWinner.length > 0) {
        btnIsWinner.on('mousedown', function (e) {
            e.preventDefault();
            e.stopPropagation();
        }).on('mouseup', function (e) {
            ResetHighlightDrawBoxes(lastHighlight);
            e.preventDefault();
            var iFrameMode = false;
            var iFrameModePassed = $('#IFrameMode').val();
            if (iFrameModePassed != undefined) {
                iFrameMode = iFrameModePassed;
            }
            var data = {};
            data.flowBlockId = encounterInfo.FlowBlockId;
            data.encounterRowId = encounterInfo.EncounterRowId;
            data.entityBaseId = encounterInfo.OppIdFocus;
            data.iFrameMode = iFrameMode;
            CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/UpdateWinnerIdOfEncounter/" + CSParameters.SportEventId, data, function (queryResult) {
                if (queryResult.error) {
                    CompuSport.Controls.Popup.ShowWarningDialog(queryResult.message);
                }
                else {
                    UpdateChart(queryResult, true);
                }
            });
        });
    }
    var btnOptions = $('#BracketBoxBtnOptionsMenu', bracketBoxControls);
    BindOptionsMenu(btnOptions, encounterInfo);
    var bracketBoxBtnToWinnerFinal = $('#BracketBoxBtnToWinnerFinal', bracketBoxControls);
    var bracketBoxBtnToWinner = $('#BracketBoxBtnToWinner', bracketBoxControls);
    var bracketBoxBtnToPrelim = $('#BracketBoxBtnToPrelim', bracketBoxControls);
    var bracketBoxBtnToLooser = $('#BracketBoxBtnToLooser', bracketBoxControls);
    if (bracketBoxBtnToWinnerFinal.length > 0) {
        bracketBoxBtnToWinnerFinal.on('mousedown', function (e) {
            e.preventDefault();
            e.stopPropagation();
        }).on('mouseup', function (e) {
            e.preventDefault();
            e.stopPropagation();
            HideEntityPopup();
            if (actualEncounterInfos.WinnerFlowBlockIdDest != null) {
                NavigateToOtherChart(actualEncounterInfos.WinnerFlowBlockIdDest, ParseDrawPosition(actualEncounterInfos.WinnerDrawPositionDest), actualEncounterInfos.OppIdFocus);
            }
        });
    }
    if (bracketBoxBtnToPrelim.length > 0) {
        bracketBoxBtnToPrelim.on('mousedown', function (e) {
            e.preventDefault();
            e.stopPropagation();
        }).on('mouseup', function (e) {
            e.preventDefault();
            e.stopPropagation();
            HideEntityPopup();
            if (actualEncounterInfos.FlowBlockIdSource != null) {
                let drawpos = "";
                if (actualEncounterInfos.DrawPositionSources != null && actualEncounterInfos.DrawPositionSources != "") {
                    drawpos = actualEncounterInfos.DrawPositionSources.split(";")[0];
                    if (drawpos != "") {
                        drawpos = ParseDrawPosition(drawpos);
                    }
                }
                NavigateToOtherChart(actualEncounterInfos.FlowBlockIdSource, drawpos, actualEncounterInfos.OppIdFocus);
            }
        });
    }
    if (bracketBoxBtnToLooser.length > 0) {
        bracketBoxBtnToLooser.on('mousedown', function (e) {
            e.preventDefault();
            e.stopPropagation();
        }).on('mouseup', function (e) {
            e.preventDefault();
            e.stopPropagation();
            HideEntityPopup();
            if (lastHighlight.LocalLooser != null) {
                bracketBoxControls.hide();
                document.CanvasChart.CenterElement(lastHighlight.LocalLooser);
            }
            else if (actualEncounterInfos.LooserFlowBlockIdDest != null) {
                NavigateToOtherChart(actualEncounterInfos.LooserFlowBlockIdDest, ParseDrawPosition(actualEncounterInfos.LooserDrawPositionDest), actualEncounterInfos.OppIdFocus);
            }
        });
    }
    if (bracketBoxBtnToWinner.length > 0) {
        bracketBoxBtnToWinner.on('mousedown', function (e) {
            e.preventDefault();
            e.stopPropagation();
        }).on('mouseup', function (e) {
            e.preventDefault();
            e.stopPropagation();
            HideEntityPopup();
            if (lastHighlight.LocalWinner != null) {
                bracketBoxControls.hide();
                document.CanvasChart.CenterElement(lastHighlight.LocalWinner);
            }
        });
    }
    if (IsDefined(typeof (CS.docHtml))) {
        CS.docHtml.trigger('panelopened', document.CanvasChart.CanvasId);
    }
}
function BindScheduleBoxOptions(lastHighlight, encounterInfos, result) {
    var scheduleBox = lastHighlight.ScheduleBoxFocus;
    var bracket = scheduleBox.parent();
    var style = scheduleBox.attr("style");
    var splittedStyle = style.split(';');
    var height = splittedStyle[2].replace("height:", "").replace("em", "").trim();
    var scheduleBoxControls = $('<div id="ScheduleBoxControls"><div id="ScheduleBoxControlsSub"><button id="ScheduleBoxBtnOptionsMenu">Options</button></div>');
    if (result.BracketBoxEditControls != null) {
        scheduleBoxControls.attr('style', style);
        scheduleBoxControls.css('height', 0);
        if (encounterInfos.OnTop) {
            if (encounterInfos.OnLeft) {
                scheduleBoxControls.addClass('TL');
            }
            else {
                scheduleBoxControls.addClass('TR');
            }
        }
        else {
            scheduleBoxControls.css('margin-top', height + 'em');
            if (encounterInfos.OnLeft) {
                scheduleBoxControls.addClass('BL');
            }
            else {
                scheduleBoxControls.addClass('BR');
            }
        }
        scheduleBoxControls.appendTo(bracket);
    }
    else {
        scheduleBoxControls.attr('style', style);
        scheduleBoxControls.css('height', 0);
        scheduleBoxControls.css('margin-top', (height / 2) + 1 + 'em');
        scheduleBoxControls.css('margin-left', '0.5em');
        scheduleBoxControls.appendTo(bracket);
    }
    result.ScheduleBoxEditControls = scheduleBoxControls;
    var scheduleBoxBtnOptionsMenu = $('#ScheduleBoxBtnOptionsMenu', scheduleBoxControls);
    BindOptionsMenu(scheduleBoxBtnOptionsMenu, encounterInfos);
}
function BindOptionsMenu(button, encounterInfos) {
    button.on('mousedown', function (e) {
        e.preventDefault();
        e.stopPropagation();
        button.focus();
    }).on('mouseup', function (e) {
        e.preventDefault();
        var encounterOptionsMenu = $('#EncounterOptionsMenu');
        var offset = button.offset();
        var width = CS.win.width();
        var height = CS.win.height();
        var middleH = width / 2;
        var middleV = height / 2;
        var cssMenu = null;
        var top = null;
        var left = null;
        var right = null;
        var bottom = null;
        //fix offset dans chrome android zoomed
        var curleft = 0;
        var curtop = 0;
        var obj = button[0];
        if (obj.offsetParent) {
            do {
                curleft += obj.offsetLeft + jQuery.css(obj, "borderLeftWidth", true);
                curtop += obj.offsetTop + jQuery.css(obj, "borderTopWidth", true);
                obj = obj.offsetParent;
            } while (obj);
        }
        //layout.csstop = curtop;
        if (offset.top - curtop > 15) {
            offset.left -= CS.win.scrollLeft();
            offset.top -= CS.win.scrollTop();
        }
        if (e.clientX > middleH) {
            left = 'auto';
            right = (width - offset.left) - button[0].offsetWidth + 'px';
        }
        else {
            left = offset.left + 'px';
            right = 'auto';
        }
        if (e.clientY > middleV) {
            top = 'auto';
            bottom = (height - offset.top) + 'px';
        }
        else {
            top = offset.top + button[0].offsetHeight + 'px';
            bottom = 'auto';
        }
        cssMenu = { left: left, right: right, top: top, bottom: bottom };
        if (encounterOptionsMenu.length == 0) {
            var iFrameMode = false;
            var iFrameModePassed = $('#IFrameMode').val();
            if (iFrameModePassed != undefined) {
                iFrameMode = iFrameModePassed;
            }
            let data = {
                isFakeEncounter: encounterInfos.IsFakeEncounter,
                hasTwoOpponents: encounterInfos.OppName0 != null && encounterInfos.OppName0 != "" && encounterInfos.OppName1 != null && encounterInfos.OppName1 != "",
                isFinished: encounterInfos.IsFinished,
                opponentSelected: encounterInfos.OppNameFocus != null && encounterInfos.OppNameFocus != "",
                hasSchedule: encounterInfos.StartDate != null,
                hasSurface: encounterInfos.SurfaceName != null && encounterInfos.SurfaceName != "",
                iFrameMode: iFrameMode
            };
            CompuSport.Ajax.Get(CSParameters.RUrl + "Charts/GetEncounterOptionsMenu/" + CSParameters.SportEventId, data, function (queryResult) {
                var $result = $(queryResult);
                $result.css(cssMenu);
                CS.body.append($result);
                $result.on('mousedown', function (e) {
                    e.preventDefault();
                    e.stopPropagation();
                    //Permet de faire en sorte que le canvas ne drag 
                    //pas sur le menu
                });
                $('#MenuEditUnsetWinner', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    CompuSport.Controls.Popup.ShowConfirmDialogV2("", JSRess.AreYouSure, function () {
                        ResetHighlightDrawBoxes(lastHighlight);
                        e.preventDefault();
                        var iFrameMode2 = false;
                        var iFrameModePassed2 = $('#IFrameMode').val();
                        if (iFrameModePassed2 != undefined) {
                            iFrameMode2 = iFrameModePassed2;
                        }
                        let data = {
                            flowBlockId: encounterInfos.FlowBlockId,
                            encounterRowId: encounterInfos.EncounterRowId,
                            entityBaseId: null,
                            iFrameMode: iFrameMode2
                        };
                        CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/UpdateWinnerIdOfEncounter/" + CSParameters.SportEventId, data, function (queryResult) {
                            if (queryResult.error) {
                                CompuSport.Controls.Popup.ShowWarningDialog(queryResult.message);
                            }
                            else {
                                UpdateChart(queryResult, true);
                            }
                        });
                    });
                    $result.remove();
                });
                $('#MenuRemoveOpponent', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.AreYouSure, function () {
                        UpdateEncounterOpponent(null);
                    });
                    $result.remove();
                });
                $('#MenuEditSchedule', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    GetSchedulePopup();
                    $result.remove();
                });
                $('#MenuEditScore', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    ShowScorePopup();
                    $result.remove();
                });
                $('#MenuCallMatchOnApp', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    CallMatch();
                    $result.remove();
                });
                $('#MenuFinishMatch', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    FinishBracketMatch();
                    $result.remove();
                });
                $('#MenuShowMatchCallCount', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    ShowMatchCallCount();
                    $result.remove();
                });
                $('#MenuShowScanDetail', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    ShowScanDetail();
                    $result.remove();
                });
                $('#MenuScoreKeeperInfo', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    ScoreKeeperInfo();
                    $result.remove();
                });
                $('#MenuEditEncounterNumber', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    GetEncounterPopup(encounterInfos.FlowBlockId, encounterInfos.EncounterNumber);
                    $result.remove();
                });
                $('#MenuDeleteScheduleAndSurface', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.AreYouSure, function () {
                        DeleteScheduleSurface(false);
                    });
                    $result.remove();
                });
                $('#MenuDeleteSurface', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    CompuSport.Controls.Popup.ShowConfirmDialogV2('', JSRess.AreYouSure, function () {
                        DeleteScheduleSurface(true);
                    });
                    $result.remove();
                });
                $('#MenuReprintMatchCard', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    var data = {};
                    data.encounterRowIds = encounterInfos.EncounterRowId;
                    data.documentToPrint = "MatchCard";
                    let controllername = "Charts";
                    var ret = ForcePrint(data, controllername, null, null);
                    $result.remove();
                });
                $('#MenuReprintPaidOut', $result).on('mouseup', function (e) {
                    e.preventDefault();
                    var data = {};
                    data.entityBaseId = encounterInfos.OppIdFocus;
                    data.flowBlockId = encounterInfos.FlowBlockId;
                    data.encounterRowIds = encounterInfos.EncounterRowId;
                    data.documentToPrint = "Payout";
                    CompuSport.Ajax.Post(CSParameters.RUrl + "Charts/ReprintPaidOut/" + CSParameters.SportEventId, data, function (queryResult) {
                        RefreshPrintDiag(null, data, "Charts", null);
                    });
                    $result.remove();
                });
                $result.slideDown(250);
            });
        }
        else {
            encounterOptionsMenu.slideUp(250, function () {
                encounterOptionsMenu.remove();
            });
        }
    });
}

//# sourceMappingURL=BracketsShared.desktop.js.map
